var map = {
	"./1.avif": [
		831,
		831
	],
	"./10.avif": [
		16,
		16
	],
	"./11.avif": [
		392,
		392
	],
	"./12.avif": [
		533,
		533
	],
	"./13.avif": [
		400,
		400
	],
	"./14.avif": [
		924,
		924
	],
	"./15.avif": [
		794,
		794
	],
	"./16.avif": [
		149,
		149
	],
	"./17.avif": [
		780,
		780
	],
	"./18.avif": [
		133,
		133
	],
	"./2.avif": [
		517,
		517
	],
	"./3.avif": [
		257,
		257
	],
	"./4.avif": [
		85,
		85
	],
	"./5.avif": [
		930,
		930
	],
	"./6.avif": [
		278,
		278
	],
	"./7.avif": [
		460,
		460
	],
	"./8.avif": [
		329,
		329
	],
	"./9.avif": [
		343,
		343
	],
	"./cat.avif": [
		864
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 879;
module.exports = webpackAsyncContext;